import { Icon } from '@iconify/react';
import Box from '@mui/material/Box';
import MuiLink from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { logError } from '../../../utils/logger';
import { ConfirmationModal, ExpandableText } from '../../shared/components';
import { deleteNewsArticle } from '../news.service';

export default function NewsArticleCard({ article, onEdit, onDelete, index }: { article: any; onEdit: any; onDelete: any; index?: any }) {
  const { title, headline, content, referenceLink, photo } = article || {};

  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await deleteNewsArticle(article.id);
      onDelete();
    } catch (err) {
      toast.error(
        logError({
          message: 'Failed to delete ',
          error: err,
          code: 'NEWS_ACTION_FAILED',
        })
      );
    } finally {
      setDeleting(false);
      setOpenDeleteConfirm(false);
    }
  };

  return (
    <>
      <div className='column'>
        <div className='row row--between'>
          <Typography variant='subtitle2' component='h3'>
            {title}
          </Typography>
          <div className='row'>
            <button type='button' className='btn text-btn text-btn--small' onClick={onEdit}>
              <Icon icon='line-md:edit-twotone' width={16} />
              Edit
            </button>
            <button
              type='button'
              className='btn text-btn text-btn--small'
              onClick={() => setOpenDeleteConfirm(true)}
            >
              <Icon icon='material-symbols:delete-outline' width={16} />
              Delete
            </button>
          </div>
        </div>
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 4fr', gap: 2 }}>
          <img src={photo?.url} alt='' className='aspect-16-9' />
          <Stack direction='column' gap={1} flex={1}>
            <Typography variant='subtitle1'>{headline}</Typography>
            <Box flex={1}>
              <ExpandableText text={content} limit={400} />
            </Box>
            <Typography variant='body2'>
              Reference link:{' '}
              <MuiLink
                href={referenceLink}
                target='_blank'
                color='link.main'
                sx={{ '&:visited': { color: 'link.main' } }}
              >
                {referenceLink}
              </MuiLink>
            </Typography>
          </Stack>
        </Box>
      </div>
      <ConfirmationModal
        open={openDeleteConfirm}
        onClose={() => setOpenDeleteConfirm(false)}
        title='Delete News Article'
        message='Are you sure you want to delete this news article?'
        onConfirm={handleDelete}
        confirmText='Delete'
        icon='mdi:delete-outline'
        loading={deleting}
      />
    </>
  );
}
